import { AreaChart, Card, Metric, Text } from "@tremor/react";
import { attendanceReports } from "./dummy/report";

export function DutyReportCardComponent() {
    return (
        <Card className="mx-auto">
            <Text>Intensitas Dinas</Text>
            <Metric>83%</Metric>
            <AreaChart
                className="mt-8 h-44"
                data={attendanceReports}
                categories={["Dinas"]}
                index="Month"
                colors={["indigo"]}
                showYAxis={false}
                showLegend={false}
            />
        </Card>
    )
}